import React from "react";
import CreateUserLinkList from "../../../features/createUserLink/components/CreateUserLinkList";
import SectionTitle from "../../../common/components/atom/SectionTitle/SectionTitle";
import HeaderTitleContent from "../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import { UserList } from "../../../features/user/components/UserList";
import PageContent from "../../../common/components/atom/PageContent/PageContent";

export default function UserListPage() {
  return (
    <PageContent>
      <HeaderTitleContent>Utilisateurs</HeaderTitleContent>
      <CreateUserLinkList.AddBtn goToMode={true} />
      <div style={{ marginTop: 50 }} />
      <SectionTitle iconType={"peoples"} iconSize={18}>
        Utilisateurs
      </SectionTitle>
      <div style={{ width: "100%", maxWidth: 1000 }}>
        <UserList.List pageSize={8} withFilter />
      </div>
    </PageContent>
  );
}
